'use client';

import QueryMatchLanding from '@/components/QueryMatchLanding';

export default function CoffeeShopAiReceptionistPage() {
  return (
    <QueryMatchLanding
      pageName="AI Receptionist for Coffee Shops"
      analyticsContext="coffee_shop_ai_receptionist"
      eyebrow="AI receptionist for coffee shops"
      h1="Do Coffee Shops Need an AI Receptionist?"
      subhead="If catering calls and 'are you open?' questions hit during the morning rush, yes. If almost nobody calls, skip it. Hear how it sounds for your shop in 60 seconds."
      bullets={[
        'Answers during the rush so the bar stays focused on drinks',
        'Captures catering and large-order details before callers hang up',
        'Handles hours, dietary FAQs, and pickup rules consistently',
        'Worth it when phone inquiries have real dollar value-not for every café',
      ]}
      industryLabel="Coffee Shops & Cafés"
      industryHref="/blog/do-coffee-shops-need-ai-receptionist"
      industryCtaLabel="Read the honest fit guide"
      accent="amber"
      showComparison={false}
      footerHeadline="Hear how it sounds for your shop"
      footerSubhead="Enter your website URL and call your AI in under a minute-no signup required."
    />
  );
}
